import React, { useEffect, useCallback, Suspense, lazy } from "react";
import "./viewNews.css";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { viewNews } from "../../Redux/Actions/newsAction";
import MainLayout from "../../Layout/mainLayout";

const NewsContent = lazy(() => import("./newsContent"));

const ViewNews = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { news, loading } = useSelector((state) => state.news);
  const data = news?.data;

  useEffect(() => {
    if (!id) return;
    if (news?.data?._id === id) return;
    dispatch(viewNews(id)).catch(() => {
      toast.error("Failed to load news details.");
    });
  }, [id, dispatch, news]);

  const formatDate = useCallback((dateString) => {
    if (!dateString) return "Not specified";
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }, []);

  if (loading) {
    return (
      <MainLayout>
        <div className="vnw-loader-wrap">
          <div className="vnw-loader" />
          <p className="vnw-loader-text">Loading news details…</p>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="vnw-wrapper">
        <div className="vnw-header">
          <div className="vnw-header-left">
            <Link to="/news_and_articles" className="vnw-back-btn">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="15 18 9 12 15 6" />
              </svg>
              Back
            </Link>
            <div className="vnw-header-divider" />
            <div>
              <div className="vnw-breadcrumb">News / List / View</div>
              <h1 className="vnw-title">News Details</h1>
            </div>
          </div>
        </div>

        <Suspense fallback={<div className="vnw-loader-wrap"><div className="vnw-loader" /></div>}>
          {data && <NewsContent data={data} formatDate={formatDate} />}
        </Suspense>
      </div>
    </MainLayout>
  );
};

export default ViewNews;